<template>
  <zm-alert type="info" class="opc-layout__sticky-alert coupon-promo-wrapper" v-if="visible" :closable="false">
    <lazy-image :img-link="promoIcon" wrapper-class="'coupon-promo-icon-wrapper'" image-class="coupon-promo-icon" />
    <div class="coupon-promo-content">
      <div class="coupon-promo-row-wrapper">
        <div class="coupon-promo-desc-wrapper">
          <p class="coupon-promo-desc"
             v-html="$t(promoDesc, [$money(nextDiscountAmount * 100, { fixedLength: 0 }), $money(nextTierAmount * 100, { fixedLength: 0 })])"></p>
          <zm-tooltip :content="promoToolTips">
            <i class="threshold-coupon-tooltip zm-icon-info-outline"></i>
          </zm-tooltip>
        </div>
      </div>
    </div>
  </zm-alert>
</template>

<script>
import LazyImage from '@/components/lazy-image.vue';
import promoIcon from '@/assets/coupon/gift.svg';
import { mapGetters } from 'vuex';
import _, { get, orderBy, reduce, includes, uniq } from 'lodash';
import { couponSourceTypeMap } from '@/views/config/coupon/helper/constant';
import { getOnlinePlanName } from '@/common/product';

export default {
  name: 'ThresholdCouponMessageBar',
  components: { LazyImage },
  data() {
    return {
      promoIcon,
      isExpand: false,
    };
  },
  computed: {
    ...mapGetters([
      'discountWithAmountMap',
      'couponState',
      'planMapFlat',
    ]),
    isMultipleTies() {
      return this.tierDiscountList.length > 1;
    },
    isThresHoldCoupon() {
      return this.couponState?.couponSourceType === couponSourceTypeMap.threshold;
    },
    visible() {
      return this.isThresHoldCoupon && this.nextTierAmount > 0;
    },
    tierDiscountList() {
      return orderBy(this.couponState?.thresholdList, ['thresholdValue'], ['asc']) || [];
    },
    isPromoAllPlans() {
      return !!this.couponState?.promoAllPlans;
    },
    thresholdList() {
      return this.isExpand ? this.tierDiscountList : [get(this.tierDiscountList, "0")].filter(Boolean)
    },
    promoDesc() {
      return 'billing.coupon.threshold.threshold_tips_desc';
    },
    promoToolTips() {
      return this.$t('billing.coupon.threshold.eligible_plan_tips');
    },
    supportCategoryNames() {
      const supportPlanCodeList = this.couponState?.supportPlanCodeList || [];

      const categoryNameList = reduce(this.planMapFlat, (res, plan) => {
        if (includes(supportPlanCodeList, plan.plan_code)) {
          res.push(getOnlinePlanName(plan));
        }

        return res;
      }, []);

      return uniq(categoryNameList).join(", ");
    },
    nextTierAmount() {
      return _.get(this.discountWithAmountMap, 'thresholdResult.nextTierAmount', 0);
    },
    nextDiscountAmount() {
      return _.get(this.discountWithAmountMap, 'thresholdResult.nextDiscountAmount', 0);
    },
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.coupon-promo-wrapper {
  &.zm-alert.zm-alert--info {
    padding: 16px;
    background: #f2fff6;
    width: 100%;

    @include media(desktop) {
      position: fixed;
      z-index: 1;
      border-radius: 0;
    }

    .zm-alert__body {
      padding-right: 0px !important;
    }

    @include media(mobile, tablet) {
      margin-bottom: 16px;
    }
  }

  .coupon-promo-content {
  }

  .coupon-promo-icon-wrapper {
    display: flex;
  }

  .coupon-promo-row-wrapper {
    display: flex;
    align-items: center;

    &:not(:nth-of-type(1)) {
      margin-top: 10px;
    }

    .coupon-promo-desc-wrapper {
      display: flex;
    }

    .zm-button__slot {
      display: flex;
      align-items: center;
      text-decoration: unset !important;

      .zm-icon-down, .zm-icon-up {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .coupon-promo-collapse-btn {
    margin-left: 8px;
    text-transform: capitalize;
    padding: 0px;
  }

  .zm-alert__description {
    display: flex;
    align-items: center;
    justify-content: center;

    @include media(mobile, tablet) {
      justify-content: flex-start;
    }
  }

  .coupon-promo-icon {
    width: 16px;
    height: 16px;
  }

  .coupon-promo-desc {
    margin-left: 8px;
  }

  .zm-alert__closebtn.zm-button {
    position: absolute;
    right: 14px;
    top: 11px;
    font-size: 13px;
    font-weight: bold;
    color: #000000;
  }

  .threshold-coupon-tooltip {
    margin-left: 5px;
    cursor: pointer;
  }
}
</style>
